import React, { useState, useEffect, useContext } from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import restService from "../../../../restService";
import { addDays } from "date-fns";
import { DatePicker } from "../../../components";
import CampaignContext from "../../../../contexts/CampaignContext";
import Select from "react-select";
import { PulseLoader } from "react-spinners";

const GeneralBrandPerformance = ({ brands }) => {
  const [campaign] = useContext(CampaignContext);
  const [data, setData] = useState([]);
  const [categories, setCategories] = useState([]);
  const [tempSearchList, setTempSearchList] = useState([]);
  const [errorMessage, setErrorMessage] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");

  const [performancePerBrandData, setPerformancePerBrandData] = useState([]);
  const [performancePerBrandCategories, setPerformancePerBrandCategories] =
    useState([]);
  const [showComparison, setShowComparison] = useState(false);
  const [searchTags, setSearchTags] = useState([]);
  const [placeholder, setPlaceholder] = useState([
    {
      label: null,
      value: null,
    },
  ]);
  const [state, setState] = useState([
    {
      startDate: addDays(new Date(), -7).setHours(0, 0, 0, 0),
      endDate: new Date().setHours(23, 59, 59, 0),
      key: "selection",
    },
  ]);
  const [isLoading, setIsLoading] = useState(true);

  const globalOptions = {
    colors: [
      "#6735A8",
      "#72ADFF",
      "#00C74C",
      "#FF6A3A",
      "#FFB53A",
      "#1e6c70",
      "#b01098",
      "#b0105d",
      "#edce05",
      "#ff0000",
      "#087478",
      "#2b5e07",
      "#690878",
      "#780839",
      "#177808",
      "#786308",
    ],
    chart: {
      type: "column",
    },
    title: {
      text: "",
    },
    legend: {
      // align: "top",
      // layout: "vertical",
      align: "left",
      verticalAlign: "top",
      squareSymbol: true,
      symbolHeight: 10,
      symbolWidth: 10,
      symbolRadius: 0,
      itemMarginBottom: 10,
      enabled: false,
    },
    credits: {
      enabled: false,
    },

    tooltip: {
      formatter: function () {
        const sum = data.reduce((a, b) => a + b.y, 0);

        return (
          "<b>" +
          this.x +
          "</b><br/>" +
          "Quantity: " +
          this.point.quantity +
          "<br />" +
          "Total: GH<span>&#8373;</span> " +
          this.y?.toLocaleString(undefined, {
            minimumFractionDigits: 2,
          }) +
          "<br/>" +
          "Percentage: " +
          ((this.y / sum) * 100)?.toFixed(2) +
          "%"
        );
      },
    },
    xAxis: {
      categories: categories,
      crosshair: true,
      type: "category",
    },
    yAxis: {
      min: 0,
      title: {
        text: "",
      },
    },

    plotOptions: {
      column: {
        pointPadding: 0,
        borderWidth: 0,
      },
    },
    series: [
      {
        colorByPoint: true,
        data,
      },
    ],
  };

  useEffect(() => {
    handleGetData();
  }, [state, tempSearchList]);

  // useEffect(() => {
  //   if (tempSearchList.length > 0) {
  //     handleGetBrandsPerLocation();
  //   } else {
  //     setShowComparison(false);
  //   }
  // }, [tempSearchList, state]);

  const handleGetData = async () => {
    setIsLoading(true);
    try {
      const {
        data: { data },
      } = await restService.Insights.getLocationPerBrand(
        campaign?.id,

        // "2022-10-01",
        // "2022-11-07"
        new Date(state[0].startDate).toISOString().slice(0, 10),
        new Date(state[0].endDate).toISOString().slice(0, 10),
        String(tempSearchList)
      );

      let outlet = data.map((res) => {
        return {
          name: res.location,
          y: res.report.brands[tempSearchList[0]],
          quantity: res.report.count[tempSearchList[0]],
        };
      });

      outlet.forEach((x) => {
        if (!x.y) {
          x.y = 0;
        }
        if (!x.quantity) {
          x.quantity = 0;
        }
      });

      setData(outlet);
      let tempCat = [];

      for (let i = 0; i < data.length; i++) {
        tempCat.push(data[i].location.replace("MELCOM", ""));

        if (data[i].location.includes("MELCOM")) {
        }
      }

      setCategories(tempCat);
      setIsLoading(false);
    } catch (error) {
      console.log(error);
      setIsLoading(false);
    }
  };

  const handleAddItems = (e) => {
    let value = e?.value;
    // let tempArr = tempSearchList;

    // tempArr.push(searchTerm);
    if (e) {
      setTempSearchList([value]);
      setPlaceholder(e);
    } else {
      setTempSearchList([]);
      setPlaceholder([{ value: "", label: "" }]);
    }
    // setSearchTerm("");
  };

  const handleSearch = async (e) => {
    const value = e.target.value;
    setSearchTerm(value);
    try {
      const {
        data: { data },
      } = await restService.Insights.searchLocationInsights(campaign.id, value);

      setSearchTags(data);
    } catch (error) {
      console.log(error);
    }
  };

  const [options, setOptions] = useState([]);

  // const options = [
  //   { value: "chocolate", label: "Chocolate" },
  //   { value: "strawberry", label: "Strawberry" },
  //   { value: "vanilla", label: "Vanilla" },
  // ];

  return (
    <div className="md:px-0 py-5">
      {/* {data && data.length < 1 ? (
        <>
          <div className="w-full flex justify-center mt-20 mb-20 ">
            <img src={require("../../../../assets/images/noData.svg")} alt="" />
          </div>
        </> */}
      {/* // ) : ( */}
      <div className="bg-white shadow w-full flex flex-col gap-2 py-4 px-8">
        <div className="flex items-center justify-between md:flex-row flex-col gap-3">
          <div className="md:min-w-[30%]  min-w-full">
            <Select
              className="border-none"
              classNamePrefix="select"
              // defaultValue={placeholder[0]}
              value={""}
              // isLoading={isLoading}
              isClearable={true}
              // isRtl={true}
              isSearchable={true}
              name="color"
              onChange={(e) => {
                handleAddItems(e);
              }}
              options={brands}
              placeholder="Select a brand..."
            />
          </div>

          <div className="border rounded">
            <DatePicker state={state} setState={setState} />
          </div>
        </div>
        {errorMessage ? (
          <p className="text-xs text-[#ff0000]">{errorMessage}</p>
        ) : (
          <div className="flex items-start">
            {/* <p
              className="cursor-pointer bg-[#3989DD] rounded-full text-xs text-white font-[700] w-[15px] h-[15px] flex items-center justify-center"
              type="button"
              data-bs-toggle="tooltip"
              data-bs-placement="right"
              title="Add up to 2 outlets to view trends"
            >
              ?
            </p> */}
          </div>
        )}

        {tempSearchList.length > 0 && (
          <div className="w-full">
            <ul className="flex w-full gap-2 flex-wrap rounded py-3 px-2">
              {tempSearchList.map((item, i) => (
                <li
                  key={i}
                  className="bg-gray-300 flex items-center gap-2 rounded text-xs px-2 py-1"
                >
                  <p>{item}</p>
                  <button
                    onClick={() => {
                      let temp = tempSearchList;
                      setErrorMessage(null);
                      let newTemp = temp.filter((x) => x !== item);

                      setTempSearchList(newTemp);

                      setPlaceholder([{ value: "", label: "" }]);
                    }}
                    className="shadow cursor-pointer px-[3px] py-[1px] bg-[#ff0000] text-[#fff]"
                  >
                    X
                  </button>
                </li>
              ))}
            </ul>
          </div>
        )}

        <div className="w-full flex items-center justify-center mt-5">
          <h3 className="font-[500] md:text-xl text-lg text-center">
            <span>
              {tempSearchList.length > 0 ? tempSearchList[0] : "Brand"}{" "}
              Performance
            </span>

            {/* Per Brand */}
          </h3>
        </div>

        {isLoading ? (
          <div className="min-h-[50vh]">
            <PulseLoader color="#FF6A3A" />
          </div>
        ) : (
          <div className="mt-11">
            <HighchartsReact
              highcharts={Highcharts}
              options={globalOptions}
              updateArgs={[true, true, true]}
            />
          </div>
        )}
      </div>
      {/* )} */}
    </div>
  );
};

export default GeneralBrandPerformance;
